<template>
  <v-dialog
    :model-value="props.modelValue"
    @update:model-value="handleOverlayClick"
    :max-width="props.width"
    :fullscreen="props.fullscreen"
    scrim="false"
  >
    <div class="dialog-wrapper">
      <v-btn
        v-if="props.showArrows"
        class="nav-arrow"
        icon="mdi-chevron-left"
        variant="text"
        size="large"
        @click="emit('leftClicked')"
      ></v-btn>

      <v-card class=" d-flex flex-column flex-grow-1">
        <v-card-title v-if="!props.hideHeader" class="d-flex align-center bg-primary text-white">
          <span class="text-h5">{{ props.title }}</span>
          <v-spacer></v-spacer>
          <v-btn
            icon="mdi-close"
            variant="text"
            @click="emit('closeDialog')"
          ></v-btn>
        </v-card-title>

        <RcDivider v-if="!props.hideHeader" class="mt-0"/>

        <v-card-text class="overflow-y-auto" style="max-height: 75vh;">
          <slot></slot>
        </v-card-text>

        <RcDivider v-if="!props.hideFooter" class="mb-0"/>

        <v-card-actions v-if="!props.hideFooter">
          <v-spacer></v-spacer>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>

      <v-btn
        v-if="props.showArrows"
        class="nav-arrow"
        icon="mdi-chevron-right"
        variant="text"
        size="large"
        @click="emit('rightClicked')"
      ></v-btn>
    </div>
  </v-dialog>
</template>

<script setup>
import RcDivider from '@/v3/components/library/divider/RcDivider.vue';
import DialogUtils from '@/v3/utils/DialogUtils';
const props = defineProps({
  modelValue: { type: Boolean, required: true },
  title: { type: String, default: 'Dialog' },
  width: { type: [String, Number], default: DialogUtils.MEDIUM },
  showArrows: { type: Boolean, default: false },
  hideFooter: { type: Boolean, default: false },
  hideHeader: { type: Boolean, default: false },
  fullscreen: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'closeDialog', 'leftClicked', 'rightClicked']);

const handleOverlayClick = (value) => {
  if (value === false) {
    emit('closeDialog');
  }
};
</script>

<style scoped>
.dialog-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.nav-arrow {
  color: white;
  background-color: rgba(0, 0, 0, 0.3);
  opacity: 0.6;
  transition: opacity 0.2s ease-in-out;
  z-index: 1;
}

.nav-arrow:hover {
  opacity: 1;
}
</style>
